import { useNavigate, useParams } from "react-router-dom";
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../components/Modal";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import useGetRequest from "../../hooks/useGetRequest";
import { useState } from "react";
import mail_successfully from "../../assets/mail_successfully.svg";

const VerifyUser = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const { token } = useParams();


  const { data, isLoading, error } = useGetRequest(
    `${API_ENDPOINTS.VERIFY_EMAIL}/${token}`
  );

  const handleClose = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalContent>
        <div className="text-center w-50 mb-3 m-auto">
          <img src={aspetto_logo} height={80} alt="aspetto_logo" />
        </div>
        <h2 className="h3 text-center mb-3">User Verification</h2>

      {
        data && <p className="text-center text-success">{data?.message}</p>
      }
   
        <p
          className={`text-center ${
            error ? "invalid-feedback" : "valid-feedback"
          }`}
        >
          {error ? error : data?.message}
        </p>
        {error && (
          <p>
            It looks like your email verification has expired. Don't worry
            you can easily request a new one! To resend the verification email,
            simply click the link below:
          </p>
        )}
        <button
          className="btn w-100 btn-warning mb-6"
          onClick={() =>
            handleClose(error ? "/resend-verification-email" : "/")
          }
          disabled={isLoading}
        >
          {error ? "Resend Verification Email" : "Back to Login Page"}
        </button>
        {!error && <img src={mail_successfully} alt="successfull" />}
      </ModalContent>
    </Modal>
  );
};

export default VerifyUser;
